import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=046e763f"
import script from "./Body.vue?vue&type=script&lang=ts"
export * from "./Body.vue?vue&type=script&lang=ts"
import style0 from "./Body.vue?vue&type=style&index=0&id=046e763f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports